import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-anchor-center-up-icon',
  templateUrl: './design-anchor-center-up.component.html'
})
export class DesignAnchorCenterUpComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
